<!-- 交收申请查询 -->
<template>
  <div id="MyTradeEntrustTheQuery">
    <el-table :data="tableData" :header-cell-style="{background:'#ffffff',borderRight:'1px solid #474747',padding:'5px 0px'}" :cell-class-name="directionClass" @sort-change="sortChange">
      <template slot="empty">
        <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 100px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
        <div v-else class="no-datas1"><div class="no-data-img" style="margin: 100px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
      </template>
      <el-table-column prop="deliveryId" label="交收单号" width="120">
      </el-table-column>
      <el-table-column prop="commodityName" label="商品名称">
      </el-table-column>
      <el-table-column prop="deliveryQuantity" label="交收数量">
      </el-table-column>
      <el-table-column prop="deliveryWeight" label="交收重量">
        <template slot-scope="scope">
          {{ parseFloat(scope.row.deliveryWeight) }}{{ scope.row.unitQuantifier }}
        </template>
      </el-table-column>
      <el-table-column prop="bsFlag" label="买/卖">
      </el-table-column>
      <!-- <el-table-column prop="deliveryType" label="交收类型">
        <template slot-scope="scope">
          {{ scope.row.deliveryType|deliveryTypeFormat }}
        </template>
      </el-table-column> -->
      <el-table-column prop="deliveryPrice" label="交收价格">
        <template slot-scope="scope">
          {{ scope.row.deliveryPrice }}
          <!-- {{ Number(Number(scope.row.deliveryPrice)===0?'--':Number(scope.row.deliveryPrice).toFixed(coinSmallDigital(selectCommodityStrategy(scope.row.commodityId)).coinDigitalNum)) | toThousands1 }} -->
        </template>
      </el-table-column>
      <el-table-column prop="deliveryFee" label="交收服务费">
        <template slot-scope="scope">
          {{ Number(scope.row.deliveryFee) | toThousands }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="150">
      </el-table-column>
      <el-table-column prop="deliveryStatus" label="交收状态">
        <template slot-scope="scope">
          {{ scope.row.deliveryStatus|deliveryStatusFormat }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="deliveryClosePl" label="交收盈亏">
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.deliveryStatus=='W'&&scope.row.deliveryType=='T'">
            <el-button type="text" @click="revoke(scope.row)">撤单</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="撤单"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="revokeOrder"
    >
      <span>您确定要撤单吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="revokeConfirm">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <el-row v-if="pageData.total">
      <el-col :span="24" class="paginateWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/*global http protocol*/
import {
  mapGetters
} from 'vuex'
import {
  bus
} from '../../../assets/js/trans/bus.js'
export default {
  name: 'MyTradeEntrustTheQuery',
  filters: {
    deliveryTypeFormat(e) {
      switch (e) {
        case '5':
          return '协议交收'
        case '6':
          return '提前交收'
        case '7':
          return '到期交收'
        case 'M':
          return '强制交收'
        case 'T':
          return '现货购销交收'
        default:
          return '未知'
      }
    },
    deliveryStatusFormat(e) {
      switch (e) {
        case 'W':
          return '待审核'
        case 'T':
          return '审核通过'
        case 'F':
          return '审核拒绝'
        case 'C':
          return '交收完成'
        case 'U':
          return '已撤销'
        default:
          return '未知'
      }
    }
  },
  props: ['flag', 'page'],
  data() {
    return {
      isNetWrong: false,
      tableData: [],
      // 是否撤单
      dialogVisible: false,
      // 分页
      pageData: {
        total: null,
        pageSizes: [5, 10, 20, 30, 40, 50, 60],
        pageSize: 20,
        currentPage: 1
      },
      // 订单号
      sOrderId: ''

    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    flag() {
      protocol.param_getDeliveryList.data.bsFlag = this.flag
      this.showData()
    }
  },
  created() {
    // 兄弟通信
    bus.$on('refreshData', () => {
      this.showData()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    selectCommodityStrategy(commodityId) {
      for (const CommodityStrategy of this.commodityStrategyGetter) {
        if (commodityId == CommodityStrategy.commodityId) {
          return CommodityStrategy
        }
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--'
      }
    },
    /**
     * s :selectCommodityStrategy(c)
     */
    coinSmallDigital(s) {
      const minPriceChange = s.minPriceChange // 最小数量变动单位
      const minAmountChange = s.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        // symbolId: this.item.symbolId,
        // numStr: /^(\-)*(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + amountPoint + '}).*$') // 数量
      }
    },
    // 是否撤单
    revokeOrder(done) {
      // const that = this
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      protocol.param_getDeliveryList.data.firmId = this.sessionInfoGetter.firmId
      protocol.param_getDeliveryList.data.page = this.pageData.currentPage - 1
      protocol.param_getDeliveryList.data.size = '' + this.pageData.pageSize
      protocol.param_getDeliveryList.data.deliveryStatus = null
      http.gPost(protocol.param_getDeliveryList).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
          } else {
            this.$message(response.data.message)
          }
        }
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
      })
      this.tableData = arr
    },
    // 撤单
    revoke(obj) {
      this.dialogVisible = true
      this.sOrderId = obj.deliveryId
    },
    revokeConfirm() {
      protocol.param_auditFirmDelivery.data.deliveryId = this.sOrderId
      http.gPost(protocol.param_auditFirmDelivery).then(response => {
        if (response.data) {
          this.$message(response.data.message)
          if (response.data && response.data.code == '0') {
            this.showData()
          }
        }
      })
      this.dialogVisible = false
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.param_getDeliveryList.data.sort[0].direction = 'ASC'
      } else {
        protocol.param_getDeliveryList.data.sort[0].direction = 'DESC'
      }
      protocol.param_getDeliveryList.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPost(protocol.param_getDeliveryList).then(response => {
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.param_getDeliveryList.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      if (row.columnIndex == 4) {
        return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
      }
      // switch (row.columnIndex) {
      //   case 2:
      //     return this.setStrClass(row.row.bsFlag, this.$t('message.Sell'), 'dropColor', 'increaseColor')
      //     break
      // }
    }
  }
}
</script>
<style scoped lang="scss">
/deep/.el-button{
  // height: 14px;
  border-radius: 4px;
  border: 1px solid #363f66;
  padding: 6px 8px;
  background: none;
}
</style>
<style>
  #MyTradeEntrustTheQuery *{
    color: #bfc3ce;
  }

#MyTradeEntrustTheQuery .el-tabs__item{
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}
#MyTradeEntrustTheQuery .el-tabs__nav-wrap::after {
  width: 0;
}
#MyTradeEntrustTheQuery .el-tabs__header{
  margin-bottom: 0;
}
#MyTradeEntrustTheQuery .el-dialog {
  border-radius: 10px;
  background:rgba(38,53,98,1);
}
#MyTradeEntrustTheQuery  .eleInputText .el-input__inner{
  background:rgba(38,53,98,1);
}
#MyTradeEntrustTheQuery .el-dialog__footer {
  padding: 20px;
}
#MyTradeEntrustTheQuery .el-dialog__footer::after {
  content: "";
  display: block;
  clear: both;
}
#MyTradeEntrustTheQuery .el-form-item__label {
  color: white;
}
.cancel-btn span {
  color: #409eff;
}

#sec .el-tabs__item{
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
#sec .is-active{
  background-color: #409EFF;
  border-radius: 30px;
  color: #FFFFFF;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border-bottom: none;
}
#sec .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),#sec .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),#sec .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),#sec  .el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding: 0 20px;
}
#sec  .el-tabs--bottom .el-tabs__item.is-bottom:last-child,#sec .el-tabs--bottom .el-tabs__item.is-top:last-child,#sec .el-tabs--top .el-tabs__item.is-bottom:last-child, #sec .el-tabs--top .el-tabs__item.is-top:last-child{
  padding: 0 20px;
}
#MyTradeEntrustTheQuery .el-pagination{
  margin-top: 50px;
  text-align: center;
}
#MyTradeEntrustTheQuery .el-loading-mask{
   background: #ffffff;
}
#MyTradeEntrustTheQuery .el-icon-more{
  color: #FFFFFF;
}
#MyTradeEntrustTheQuery .selecttime{
  margin: 15px;
}
#MyTradeEntrustTheQuery .new-title-record-bonus-box .el-tabs__item.is-active {
  border-bottom: none;
}
#MyTradeEntrustTheQuery .el-date-editor--datetime .el-input__inner {
color: #EEEFF7;
height: 40px;
box-sizing: border-box;
margin: 0 auto;
border-radius: 2px;
border: 1px solid rgba(220,223,234,.3);
background: linear-gradient(360deg, rgba(38,53,98,1) 0, rgba(38,53,98,1) 100%);
cursor: pointer;
}

</style>
<style>
#MyTradeEntrustTheQuery .el-table--border::after,#MyTradeEntrustTheQuery .el-table--group::after, .el-table::before{
 background-color:transparent;
}
#MyTradeEntrustTheQuery .el-table td,#MyTradeEntrustTheQuery .el-table th.is-leaf{
     border-bottom: 1px solid #474747;
}
#MyTradeEntrustTheQuery .el-table--border,#MyTradeEntrustTheQuery .el-table--group{
 border:none;
}
#MyTradeEntrustTheQuery .el-table td div{
  text-align:center;
  font-size:14px;
  color:#fff;
}
#MyTradeEntrustTheQuery .el-table--border td, #MyTradeEntrustTheQuery .el-table--border th,#MyTradeEntrustTheQuery .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #474747;
}
#MyTradeEntrustTheQuery .el-pagination button:disabled,
#MyTradeEntrustTheQuery .el-pagination .btn-prev,
#MyTradeEntrustTheQuery .el-pagination .btn-next,
#MyTradeEntrustTheQuery .el-pager li,
#MyTradeEntrustTheQuery .el-pagination__editor.el-input .el-input__inner,
#MyTradeEntrustTheQuery .el-pagination .el-select .el-input .el-input__inner,
#MyTradeEntrustTheQuery .el-table table tr,
#MyTradeEntrustTheQuery .el-table th,
#MyTradeEntrustTheQuery .el-table,
#MyTradeEntrustTheQuery .el-table__footer-wrapper tbody td,
#MyTradeEntrustTheQuery .el-table__header-wrapper tbody td {
  background: #ffffff;
}
#MyTradeEntrustTheQuery .el-table td,#MyTradeEntrustTheQuery .el-table th{
    padding:2px 0;
}
#MyTradeEntrustTheQuery .el-table__footer-wrapper td{
    border-top:none;
}
#MyTradeEntrustTheQuery .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
#MyTradeEntrustTheQuery .el-table__body tr.current-row > td,
#MyTradeEntrustTheQuery .el-table__body tr.hover-row.current-row > td,
#MyTradeEntrustTheQuery .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#MyTradeEntrustTheQuery .el-table__body tr.hover-row.el-table__row--striped > td,
#MyTradeEntrustTheQuery .el-table__body tr.hover-row > td,
#MyTradeEntrustTheQuery  .el-table th.el-table__cell {
  background: #ffffff;
}
#MyTradeEntrustTheQuery .el-table__header-wrapper th > .cell{
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-align:center;
}
#MyTradeEntrustTheQuery .el-table .el-table__cell{
  padding:4px 0;
  /* border-right: 1px solid #505050; */
}
#MyTradeEntrustTheQuery .el-table td.el-table__cell,#MyTradeEntrustTheQuery .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);;
}

</style>
